import React, { useState, useEffect, useContext } from "react";
import config from "../../../config";
import styles from "./styles/ChangePwd.module.css"
import { pbdkf2 } from "../../../Utils/OstreonEncryption";
import Confirmation from "../../Confirmation/Confirmation";
import SHA from "sha.js";
import { UserData } from "../../../Context/DataContext";
import { cancelPWDchange, handlePwdChange } from "../../../Utils/RenewPWD";
import { Success } from "./Success";
import { useAuth } from "../../../Context/AuthContext";
import { OnProgress } from "./OnProgress";
import { validatePasswordStrength } from "../../../Utils/passwordRequirements";
import PasswordRequirements from "../../Password Requirements/PasswordRequirements";
import { ChangePasswordOTP, fetchChangePassword } from "../../../Utils/changeEmail";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import parse from "html-react-parser";
const base_url=config.base_url
function ChangePwd({onClose}) {
    const [otpShow, setOtpShow] = useState();
    const [otpcode, setOtp] = useState('');
    const [timeLeft, setTimeLeft] = useState(0);
    const [timerActive, setTimerActive] = useState(false);
    const websiteCurrentLang = useContext(LanguageContext).language;
    const [content, setContent] = useState(
      websiteCurrentLang.content.User.MyAccount.ChangePwd
    );
    const [dublicatedcontent, setDublicatedContent] = useState(
      websiteCurrentLang.content.DublicatedText
    );
    useEffect(() => {
      setContent(websiteCurrentLang.content.User.MyAccount.ChangePwd);
      setDublicatedContent(websiteCurrentLang.content.DublicatedText);
    }, [websiteCurrentLang]);
    const Progress = (status)=>{
        setModal(<OnProgress title={dublicatedcontent?.work_in_progress} status={status} subtext={content.changePwdText1} />)
    }

    useEffect(() => {
        let interval;

        if (timerActive && timeLeft > 0) {
            interval = setInterval(() => {
                setTimeLeft(prevTime => prevTime - 1);
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [timerActive, timeLeft]);

    const handleStartTimer = () => {
        setTimeLeft(30);
        setTimerActive(true);
    };

    const [modal, setModal] = useState(null)
    const userData=UserData()
    const auth = useAuth()
    var private_key = userData.private_key
    const [sending, setSending] = useState(false)
    const [data, setData] = useState({
        "oldpassword":"",
        "newpassword1":"",
        "newpassword2":""
    })
    const [error, setError] = useState({
        "oldpassword":"",
        "newpassword1":"",
        "newpassword2":"",
        "general":"",
        "otpcode": ""
    })

    const [pwdreq, setpwdreq] = useState();
    const [pwdreqconfirm, setpwdreqConfirm] = useState();
    const [passwordVisibility, setPasswordVisibility] = useState({})
    const handleTogglePassword = (fieldName) => {
        setPasswordVisibility((prevState) => ({
          ...prevState,
          [fieldName]: !prevState[fieldName],
        }));
    };
    const isPasswordVisible = (fieldName) => {
        return passwordVisibility[fieldName];
    };
    // password popups

    const [passwordIsFocused, setPasswordIsFocused] = useState(false)

    const [hideTimeout, setHideTimeout] = useState(null);

    const handlePasswordFocusIn = () => {
        clearTimeout(hideTimeout); // Clear any existing timeout
        setPasswordIsFocused(true);
        setConfirmPasswordIsFocused(false);
    };

    const handlePasswordFocusOut = () => {
         // Set a delay before hiding the div
        const timeout = setTimeout(() => {
            setPasswordIsFocused(false);
        }, 300); // Adjust the delay time (in milliseconds) as needed
        setHideTimeout(timeout);
    };

    // password confirm popups

    const [confirmPasswordIsFocused, setConfirmPasswordIsFocused] = useState(false);

    const [hideConfirmTimeout, setHideConfirmTimeout] = useState(null);

    const handleConfirmPasswordFocusIn = () => {
        clearTimeout(hideConfirmTimeout); // Clear any existing timeout
        setConfirmPasswordIsFocused(true);
        setPasswordIsFocused(false);
    };  

    const handleConfirmPasswordFocusOut = () => {
         // Set a delay before hiding the div
        const timeout = setTimeout(() => {
            setConfirmPasswordIsFocused(false);
        }, 300); // Adjust the delay time (in milliseconds) as needed
        setHideConfirmTimeout(timeout);
    };

    useEffect(()=>{
        setpwdreq(validatePasswordStrength(data.newpassword1, true));
        setpwdreqConfirm(validatePasswordStrength(data.newpassword2));
    }, [data.newpassword1]);

    const checkPassRequirements = () => {
        setpwdreq(validatePasswordStrength(data.newpassword1, true));
    }
    const checkPassConfirmRequirements = () => {
        setpwdreq(validatePasswordStrength(data.newpassword1, true));
        setpwdreqConfirm(validatePasswordStrength(data.newpassword2, data["newpassword1"] === data["newpassword2"] && data["newpassword2"] !== ''));
    }
    useEffect(()=>{
        checkPassRequirements()
    }, [data.newpassword1])

    useEffect(()=>{
        checkPassConfirmRequirements()
    }, [data.newpassword2])

    const uploadState = (state) =>{
        setModal(<OnProgress title={dublicatedcontent?.work_in_progress} status={state} subtext={content.changePwdText1} />)
    }
    const cleanErrors=()=>{
        setTimeout(() => {
            setError({
                "oldpassword":"",
                "newpassword1":"",
                "newpassword2":"",
                "general":"",
                "otp":""
            })
        }, 5000);
    }
    const getPermission = () =>{
        return new Promise(async (resolve, reject) => {
            const [pbdkf2hash, ] = await pbdkf2(data.oldpassword, 'OSTREON', 100000, 32*8)
            fetch(base_url+'user/PWDpermissions', {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-type': 'application/x-www-form-urlencoded',
                    'credentials':'include'
                },
                body: `password=${pbdkf2hash}`,
                credentials:'include'
            }).then((res)=>{
                return res.json()
            }).then(data=>{
                if(data.error===""){
                    // setError({...error, "oldpassword":"Password valid"})
                    resolve()
                }
                else{
                    setError({...error, "oldpassword":data.error})
                    reject()
                }
                cleanErrors()
            }).catch(e=>{
                setError({...error, "oldpassword":dublicatedcontent.dublicatedText78})
                reject()
            })
        })
        
    }
    const handleClick = async () =>{
        var error_={
            "oldpassword":"",
            "newpassword1":"",
            "newpassword2":""
        }
        var isError=false;
        if(data.oldpassword === data.newpassword1) {
            error_={...error_, "newpassword1":content.changePwdError2}
            isError=true
        }
        if (data.oldpassword===""&&!auth.PWDPermission){
            error_={...error_, "oldpassword":content.changePwdError3}
            isError=true
        }
        if (data.newpassword1===""){
            error_={...error_, "newpassword1":content.changePwdError4}
            isError=true
        }
        if (data.newpassword1!==data.newpassword2){
            const mes=content.changePwdError5;
            error_={...error_,"newpassword2":mes}
            isError=true
        }
        
        if (Object.keys(pwdreq).some((key) => pwdreq[key]==="")) {
            error_={...error_, "newpassword1":content.changePwdError6}
            isError=true
        }
        if (data.newpassword2===""){
            error_={...error_, "newpassword2":content.changePwdError7}
            isError=true
        }
        if (isError){
            setError(error_)
            setTimeout(() => {
                cleanErrors()
            }, 5000);
            return
        } else {
            Progress(content.changePwdText2);
            setSending(true)
            return fetchChangePassword(data.oldpassword).then(res=>{
                setModal(null);
                if (res.status===200) {
                    setOtpShow(true);
                    handleStartTimer();
                }
                else if (res.status===403) setError({...error, "oldpassword": content.changePwdError8})
                else setError({...error, "general":dublicatedcontent.dublicatedText78 })
                setTimeout(() => {
                    cleanErrors()
                }, 5000);
            }).finally(_=>{
                setSending(false)
            })
        }
    }

    const sendOTP = ()=>{
        if (otpcode === "") {
            setError({ ...error, "otpcode": content.changePwdError9 })
            setTimeout(() => {
                setError({ ...error, "otpcode": "" })
            }, 5000);
            return
        }
         ChangePasswordOTP(otpcode||undefined)
         .then(res=>{
            if (res.status===200) return // User has enough permissions and we can continue password change process
            else if (res.status===403) throw new Error('Unauthorized')//need to set an error. This means inserted OTP is not correct
            else{
                //this means another type of error happened. "Something went wrong. Try later"
                throw new Error()
            }
         })
         .then(() => {
             return new Promise((resolve) => {
                resolve();
             });
         })
         .then(async ()=>{
             setModal(<OnProgress title={dublicatedcontent?.work_in_progress} status={content.changePwdText3} subtext={content.changePwdText1}/>)
             const key=`${data.newpassword1}:${data.newpassword1}:${data.newpassword1}:OSTREON`
             const new_private_key = SHA('sha256').update(key).digest('hex')
             setModal(<OnProgress title={dublicatedcontent?.work_in_progress} status={content.changePwdText4} subtext={content.changePwdText1} />)
             var [old_hash, ] = await pbdkf2(data.oldpassword, 'OSTREON', 100000, 32*8)
             if (!data.oldpassword) old_hash=undefined
             handlePwdChange(private_key, new_private_key, uploadState, userData, data.newpassword1, old_hash, dublicatedcontent)
             .then(async(e)=>{
                 const [pbdkf2hash, ] = await pbdkf2(data.newpassword1, 'OSTREON', 100000, 32*8)
                 auth.updateHash(pbdkf2hash)
                 onClose(data.newpassword1);
                 setModal(<Success />)
             })
             .catch(e=>{
                 uploadState(`Error: ${e.toString()}`)
                 setTimeout(()=>{
                     uploadState('Undoing changes')
                     cancelPWDchange().then(()=>{
                         uploadState('Changes were undone')
                     }).catch(()=>{
                         uploadState('Contact support')
                     })
                     setTimeout(()=>{
                         setModal()
                     }, 3000)
                 }, 3000)
             })
         })
         .catch(e=>setModal(null))
    }
    
    const handleEnter = (e) =>{
        if (e.key==="Enter"){
            handleClick()
        }
    }
    return (
        <div className={styles.main} onKeyDown={handleEnter}>

            {otpShow ? (
            <div className={styles.change_container}>
                <div className={styles.change_title}>{content.changePwdTitle1}</div>
                <div className={styles.row}>{content.changePwdText5} <span className={styles.blue_text}>{auth?.email}</span></div>
                <div className={styles.row}>{content.changePwdText6}</div>
                {error.otpcode ? <div className={styles.error_message}>{error.otpcode}</div> : null}

                <div className={styles.otp_actions}>
                    <input value={otpcode} onChange={e => setOtp(e.target.value)} className={styles.user_input} placeholder="OTP code"></input>

                    <div className={styles.confirm_btn} onClick={() => sendOTP()}>{content.changePwdText7}</div>

                    {timerActive && timeLeft > 0
                    ? (
                        <div className={`${styles.resend_btn} ${styles.disabled}`}>
                            {content.changePwdText8} {timeLeft}s
                        </div>
                    )
                    : (
                        <div className={styles.resend_btn} onClick={() => handleClick()}>
                            {content.changePwdText9}
                        </div>
                    )}
                </div>
            </div>
            ) :
            (
                <>
                <div className={styles.field}>
                    {
                        auth.PWDPermission
                        ?null
                        : (
                        <div>
                            <div className={styles.input_title}>
                            {content.changePwdText10}
                            </div>
                            <div className={styles.input_wrap}>
                                <input type={isPasswordVisible('passwordField1') ? 'text' : 'password'} name="passwordField1" onChange={(e)=>{setData({...data, "oldpassword":e.target.value})}} className={`${styles.user_input} ${error.oldpassword ? styles.input_error : ''}`} placeholder={content.changePwdText10}></input>
                                <div onClick={() => handleTogglePassword('passwordField1')} className={styles.password_button}>
                                    <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.99994 10.2062C7.20744 10.2062 5.75244 8.99375 5.75244 7.5C5.75244 6.00625 7.20744 4.79375 8.99994 4.79375C10.7924 4.79375 12.2474 6.00625 12.2474 7.5C12.2474 8.99375 10.7924 10.2062 8.99994 10.2062ZM8.99994 5.73125C7.82994 5.73125 6.87744 6.525 6.87744 7.5C6.87744 8.475 7.82994 9.26875 8.99994 9.26875C10.1699 9.26875 11.1224 8.475 11.1224 7.5C11.1224 6.525 10.1699 5.73125 8.99994 5.73125Z" fill="#B3B3B3"/>
                                        <path d="M9.00006 13.1375C6.18006 13.1375 3.51756 11.7625 1.68756 9.375C0.892559 8.34375 0.892559 6.6625 1.68756 5.625C3.52506 3.2375 6.18756 1.8625 9.00006 1.8625C11.8126 1.8625 14.4751 3.2375 16.3051 5.625C17.1001 6.65625 17.1001 8.3375 16.3051 9.375C14.4751 11.7625 11.8126 13.1375 9.00006 13.1375ZM9.00006 2.8C6.57756 2.8 4.26006 4.0125 2.64006 6.13125C2.07756 6.8625 2.07756 8.1375 2.64006 8.86875C4.26006 10.9875 6.57756 12.2 9.00006 12.2C11.4226 12.2 13.7401 10.9875 15.3601 8.86875C15.9226 8.1375 15.9226 6.8625 15.3601 6.13125C13.7401 4.0125 11.4226 2.8 9.00006 2.8Z" fill="#B3B3B3"/>
                                    </svg> 
                                </div>
                            </div>
                            {error.oldpassword?<div className={styles.error_message}>{error.oldpassword}</div>:null}</div>
                        )
                    }
                </div>
                <div className={styles.field}>
                    <div className={styles.input_title}>{content.changePwdText11}</div>
                    <div className={styles.input_wrap}>
                        <input onChange={(e)=>{
                            setData({...data, "newpassword1":e.target.value})}} onFocus={()=>handlePasswordFocusIn()} onBlur={e => {handlePasswordFocusOut()}} type={isPasswordVisible('passwordField2') ? 'text' : 'password'} name="passwordField2" className={`${styles.user_input} ${error.newpassword1 ? styles.input_error : ''}`} placeholder={content.changePwdText11}></input>
                        <div onClick={() => handleTogglePassword('passwordField2')} className={styles.password_button}>
                            <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.99994 10.2062C7.20744 10.2062 5.75244 8.99375 5.75244 7.5C5.75244 6.00625 7.20744 4.79375 8.99994 4.79375C10.7924 4.79375 12.2474 6.00625 12.2474 7.5C12.2474 8.99375 10.7924 10.2062 8.99994 10.2062ZM8.99994 5.73125C7.82994 5.73125 6.87744 6.525 6.87744 7.5C6.87744 8.475 7.82994 9.26875 8.99994 9.26875C10.1699 9.26875 11.1224 8.475 11.1224 7.5C11.1224 6.525 10.1699 5.73125 8.99994 5.73125Z" fill="#B3B3B3"/>
                                <path d="M9.00006 13.1375C6.18006 13.1375 3.51756 11.7625 1.68756 9.375C0.892559 8.34375 0.892559 6.6625 1.68756 5.625C3.52506 3.2375 6.18756 1.8625 9.00006 1.8625C11.8126 1.8625 14.4751 3.2375 16.3051 5.625C17.1001 6.65625 17.1001 8.3375 16.3051 9.375C14.4751 11.7625 11.8126 13.1375 9.00006 13.1375ZM9.00006 2.8C6.57756 2.8 4.26006 4.0125 2.64006 6.13125C2.07756 6.8625 2.07756 8.1375 2.64006 8.86875C4.26006 10.9875 6.57756 12.2 9.00006 12.2C11.4226 12.2 13.7401 10.9875 15.3601 8.86875C15.9226 8.1375 15.9226 6.8625 15.3601 6.13125C13.7401 4.0125 11.4226 2.8 9.00006 2.8Z" fill="#B3B3B3"/>
                            </svg> 
                        </div>
                    </div>
                    {error.newpassword1?<div className={styles.error_message}>{error.newpassword1}</div>:null}

                    <div className={styles.password_popups}>
                        {passwordIsFocused && <PasswordRequirements req={pwdreq}/>}
                    </div>
                </div>
                <div className={styles.field}>
                    <div className={styles.input_title}>{content.changePwdText12}</div>
                    <div className={styles.input_wrap}>
                        <input onChange={(e)=>setData({...data, "newpassword2":e.target.value})} type={isPasswordVisible('passwordField3') ? 'text' : 'password'} name="passwordField3" onFocus={()=>handleConfirmPasswordFocusIn()} onBlur={e => {handleConfirmPasswordFocusOut()}} className={`${styles.user_input} ${error.newpassword2 ? styles.input_error : ''}`} placeholder={content.changePwdText12}></input>
                        <div onClick={() => handleTogglePassword('passwordField3')} className={styles.password_button}>
                            <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.99994 10.2062C7.20744 10.2062 5.75244 8.99375 5.75244 7.5C5.75244 6.00625 7.20744 4.79375 8.99994 4.79375C10.7924 4.79375 12.2474 6.00625 12.2474 7.5C12.2474 8.99375 10.7924 10.2062 8.99994 10.2062ZM8.99994 5.73125C7.82994 5.73125 6.87744 6.525 6.87744 7.5C6.87744 8.475 7.82994 9.26875 8.99994 9.26875C10.1699 9.26875 11.1224 8.475 11.1224 7.5C11.1224 6.525 10.1699 5.73125 8.99994 5.73125Z" fill="#B3B3B3"/>
                                <path d="M9.00006 13.1375C6.18006 13.1375 3.51756 11.7625 1.68756 9.375C0.892559 8.34375 0.892559 6.6625 1.68756 5.625C3.52506 3.2375 6.18756 1.8625 9.00006 1.8625C11.8126 1.8625 14.4751 3.2375 16.3051 5.625C17.1001 6.65625 17.1001 8.3375 16.3051 9.375C14.4751 11.7625 11.8126 13.1375 9.00006 13.1375ZM9.00006 2.8C6.57756 2.8 4.26006 4.0125 2.64006 6.13125C2.07756 6.8625 2.07756 8.1375 2.64006 8.86875C4.26006 10.9875 6.57756 12.2 9.00006 12.2C11.4226 12.2 13.7401 10.9875 15.3601 8.86875C15.9226 8.1375 15.9226 6.8625 15.3601 6.13125C13.7401 4.0125 11.4226 2.8 9.00006 2.8Z" fill="#B3B3B3"/>
                            </svg> 
                        </div>
                    </div>
                    {error.newpassword2?<div className={styles.error_message}>{error.newpassword2}</div>:null}
                    <div className={styles.password_confirm_popups}>
                        {confirmPasswordIsFocused && <PasswordRequirements req={pwdreqconfirm}/>}
                    </div>
                </div>
                {error.general?<div className={styles.error_message}>{error.general}</div>:null}
                <div className={styles.buttons_div}>
                    <div onClick={()=>onClose()} className={styles.cancel_button}>{content.changePwdText13}</div>
                    <div onClick={()=>{
                        handleClick()
                    }} className={styles.save_button}>{sending ? content.changePwdText14 : content.changePwdText15}</div>
                </div>

                <div className={styles.pass_hint}>

                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.85156 6.74961V5.39961C5.85156 3.16536 6.52656 1.34961 9.90156 1.34961C13.2766 1.34961 13.9516 3.16536 13.9516 5.39961V6.74961" stroke="#26313D" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.2734 14.8505H6.52344C3.82344 14.8505 3.14844 14.1755 3.14844 11.4755V10.1255C3.14844 7.42549 3.82344 6.75049 6.52344 6.75049H13.2734C15.9734 6.75049 16.6484 7.42549 16.6484 10.1255V11.4755C16.6484 14.1755 15.9734 14.8505 13.2734 14.8505Z" stroke="#26313D" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12.5975 10.7999H12.6035" stroke="#26313D" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9.89825 10.7999H9.90431" stroke="#26313D" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.19707 10.7999H7.20314" stroke="#26313D" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div className={styles.pass_hint_text}>
                        <div className={styles.strong}>{content.changePwdText16}</div>
                        {content.changePwdText17} <a href="zero" target="_blank" className={styles.bluetext}>{parse(content.changePwdText18)}</a>

                        <div className={styles.red_text}>
                        {content.changePwdText19}
                        </div>
                    </div>
                </div>
                </>
            )}
            
            {
                modal?
                <div style={{position:"relative", zIndex:"3"}}>
                    {modal}
                </div>
                :null
            }
        </div>
    );
}

export default ChangePwd;
